import { doc, updateDoc, writeBatch, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

// Forum posts (`posts`) and their replies (`postComments`)

export function editForumPost(postId, text) {
  return updateDoc(doc(db, "posts", postId), { post: text, edited_at: serverTimestamp() });
}

// Deletes the post together with its replies in one atomic batch
export async function deleteForumPost(postId, commentIds = []) {
  const batch = writeBatch(db);
  commentIds.forEach(id => batch.delete(doc(db, "postComments", id)));
  batch.delete(doc(db, "posts", postId));
  await batch.commit();
}

export function editForumComment(commentId, text) {
  return updateDoc(doc(db, "postComments", commentId), { comment: text, edited_at: serverTimestamp() });
}

export async function deleteForumComment(commentId) {
  const batch = writeBatch(db);
  batch.delete(doc(db, "postComments", commentId));
  await batch.commit();
}
